import { render, staticRenderFns } from "./HandbookLayout.vue?vue&type=template&id=517d7540&scoped=true"
import script from "./HandbookLayout.vue?vue&type=script&lang=ts"
export * from "./HandbookLayout.vue?vue&type=script&lang=ts"
import style0 from "./HandbookLayout.vue?vue&type=style&index=0&id=517d7540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d7540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
